export default class StringUtils {
  public static cutBySymbolsLength = (string?: string, length?: number): string => {
    if (string && length) {
      return string.length > length ? `${string.substring(0, length)}...` : string.substring(0, length);
    }
    return "";
  };

  public static formatAsPhoneNumber = (number: string | undefined): string => {
    if (!number) {
      return "";
    }

    const isWasPlus = number.includes("+");

    let numberCopy = `${number}`.replace("+", "");
    for (let i = numberCopy.length; i < 11; i += 1) {
      numberCopy = ` ${numberCopy}`;
    }

    const block1 = numberCopy.substring(0, 1).replace(/ /g, "");
    const block2 = numberCopy.substring(1, 4).replace(/ /g, "");
    const block3 = numberCopy.substring(4, 7).replace(/ /g, "");
    const block4 = numberCopy.substring(7, 12).replace(/ /g, "");

    if (block1 && block2 && block3 && block4) {
      return `${isWasPlus ? "+" : ""}${block1} (${block2}) ${block3} ${block4}`;
    }

    if (block2 && block3 && block4) {
      if (block2.length === 3) {
        return `${isWasPlus ? "+" : ""}(${block2}) ${block3} ${block4}`;
      }
      if (block2.length === 2) {
        return `${isWasPlus ? "+" : ""}${block2}) ${block3} ${block4}`;
      }
      if (block2.length === 1) {
        return `${isWasPlus ? "+" : ""}${block2}) ${block3} ${block4}`;
      }
    }

    if (block3 && block4) {
      return `${isWasPlus ? "+" : ""}${block3} ${block4}`;
    }

    return `${isWasPlus ? "+" : ""}${block4}`;
  };

  public static clearPhoneFormating = (number: string): string => {
    return number.replace(/ /g, "").replace("-", "").replace("(", "").replace(")", "");
  };

  /**
   * Coverts number into number with two digits after dot.
   *
   * For example:
   *  10    => 10.00
   *  10.1  => 10.10
   *  10.11 => 10.11
   */
  public static getNumberWithHundredthsZeros = (number: number): string => {
    const [beforeDot, afterDot] = `${number}`.split(".");

    const formattedBeforeDot = beforeDot
      .split("")
      .reverse()
      .join("")
      .match(/.{1,3}/g)
      ?.join(",")
      .split("")
      .reverse()
      .join("");

    if (!afterDot) {
      return `${formattedBeforeDot}.00`;
    }

    if (afterDot.length === 1) {
      return `${formattedBeforeDot}.${afterDot}0`;
    }

    if (afterDot.length > 2) {
      return `${formattedBeforeDot}.${afterDot.substr(0, 2)}`;
    }

    return `${formattedBeforeDot}.${afterDot}`;
  };
}
